import { createContext } from 'react';

// DOM node of the page's fixed right column (rightCol aside), or null until mounted.
export const RightColContext = createContext(null);
